export class NavioViagemRequest {
    CNPJCliente: string;
    CNPJProvedor: string;
    tipo: string;
    dataIni: Date;
    dataFim: Date;
    idUsuario: number;
}